import Shop from "@/views/Shop/Shop.vue";
import PurchaseRequest from "@/views/Shop/PurchaseRequest.vue";
import Budget from "@/views/Shop/Budget.vue";
import Projections from "@/views/Shop/Projections.vue";
import Quotes from "@/views/Shop/Quotes.vue";
import QuotesGroup from "@/views/Shop/QuotesGroup.vue"; 
import QuoteDetailView from "@/views/Shop/QuoteDetailView.vue";
import ViewQuoteGroup from "@/views/Shop/ViewQuoteGroup.vue";
import PurchaseOrder  from "@/views/Shop/PurchaseOrder.vue"
import Approved  from "@/views/Shop/Approved.vue"
import ViewOrders from "@/components/Shop/ViewOrders.vue";
import ViewReceptions from "@/components/Shop/ViewReceptions.vue";
import DownloadQuotation from "@/components/Shop/DownloadQuotation.vue"
import Receptions from "@/views/Shop/Receptions.vue"
import Approvers from "@/views/Maintenance/Approvers.vue"
import ApprovalRoutes from "@/views/Maintenance/ApprovalRoutes.vue"
import InvoiceShop from "@/views/Shop/InvoiceShop.vue"
import Debit from "@/views/Shop/DebitNotes.vue"
import CreditNoteShop from "@/views/Shop/CreditNoteShop.vue"
import Reports from "@/views/Shop/Reports.vue"

 const shop={
    path: "/shop",
    name: "Shop",
    component: Shop,
    meta: {
      SHOP: true,
    },
    children: [
      {
        path: "Budget",
        name: "Budget",
        component: Budget,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "CreditNoteShop",
        name: "CreditNoteShop",
        component: CreditNoteShop,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "Projections",
        name: "Projections",
        component: Projections,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "purchase_request",
        name: "PurchaseRequest",
        component: PurchaseRequest,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "quotes",
        name: "Quotes",
        component: Quotes,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "quotesGroup",
        name: "QuotesGroup",
        component: QuotesGroup,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "quote_detail/:quotation_id/:supplier_id", 
        name: "QuoteDetailView",
    
        component: QuoteDetailView,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "view_quote_group/:id",
        name: "ViewQuoteGroup",
        component: ViewQuoteGroup,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "view_order/:id/:type/:typeb",
        name: "ViewOrders",
        component: ViewOrders,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "view_receptions/:order_id/:id",
        name: "ViewReceptions",
        component: ViewReceptions,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "purchase_order",
        name: "PurchaseOrder",
        component: PurchaseOrder,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "download_quotation/:quotation_id/:supplier_id",
        name: "DownloadQuotation",
        component: DownloadQuotation,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "receptions",
        name: "Receptions",
        component: Receptions,
        meta: {
          code: "SHOP-131", // VER Receptions: controla el acceso a la lista de recepciones
        },
      },
      {
        path: "approved",
        name: "Approved",
        component: Approved,
        meta: {
          SHOP: true,
        },
      },
      
      {
        path: "approvers",
        name: "Approvers",
        component: Approvers,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "ApprovalRoutes",
        name: "ApprovalRoutes",
        component: ApprovalRoutes,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "invoice_shop",
        name: "InvoiceShop",
        component: InvoiceShop,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "debit_notes",
        name: "DebitNotes",
        component: Debit,
        meta: {
          SHOP: true,
        },
      },
      {
        path: "reports",
        name: "ShopReports",
        component: Reports,
        meta: {
          SHOP: true,
        },
      },

    ],
  }
  export default shop